import { render, staticRenderFns } from "./tagOne.vue?vue&type=template&id=7f7bbe8a&scoped=true"
import script from "./tagOne.vue?vue&type=script&lang=js"
export * from "./tagOne.vue?vue&type=script&lang=js"
import style0 from "./tagOne.vue?vue&type=style&index=0&id=7f7bbe8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7bbe8a",
  null
  
)

export default component.exports